import script from "./DepartmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentCard.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentCard.vue?vue&type=style&index=0&id=4dbd02e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbd02e2"]])

export default __exports__